import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Tooltip from '../Tooltip';

const MapFocusButton = ({ isFocused, onClick, intl }) => {
    const label = intl.formatMessage({ id: isFocused ? 'map.exitFocusOnMap' : 'map.focusOnMap' });

    return (
        <Tooltip placement="left" overlay={<span className="light-text">{label}</span>}>
            <button
                className="map-btn map-btn--single map-btn--focus"
                onClick={onClick}
                aria-label={label}
                data-testid="map-focus-toggle"
            >
                <i className="material-symbols">{isFocused ? 'collapse_content' : 'expand_content'}</i>
            </button>
        </Tooltip>
    );
};

MapFocusButton.propTypes = {
    isFocused: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default injectIntl(MapFocusButton);
